<template>
  <component
  :is="inputCmp"
  v-bind="$attrs"
  :label="label"
  v-on="$listeners"
  :defaultCountry="defaultCountry"
  >

  </component>
</template>

<script>

  export default {
    name: "InteractionDetailsInput",
    props: {
      interactionType: {
        type: String,
        required: true,
        validator(val) {
          return ['client_phone', 'business_phone', 'online', 'zoom', 'client_location', 'default_business_location', 'business_location', 'skype'].indexOf(val) !== -1;
        }
      },
      defaultCountry: {
        type: String,
        default: '',
      },
    },
    computed: {
      label() {
        let res;
        switch (this.interactionType) {
          case 'client_location':
          case 'default_business_location':
          case 'business_location':
            res = this.$t('settings.service_page.service_location.interaction_details.location');
            break;
          case 'client_phone':
            res = this.$t('appointment.info.interaction_types.client_phone.label');
            break;
          case 'business_phone':
            res = this.$t('settings.client_card.client_fields_types.phone');
            break;
          case 'skype':
            res = this.$t('appointment.info.interaction_types.skype.label');
            break;
            case 'online':
              res = this.$t('appointment.info.interaction_types.online.label');
            break;
        }
        return res
      },
      inputCmp() {
        let res;
        switch (this.interactionType) {
          case 'skype':
          case 'online':
            res = () => import("@/modules/common/components/VcitaTextField/VcitaTextField.vue")
            break;
          case 'client_phone':
          case 'business_phone':
            res = () => import("@/modules/common/components/PhoneInput/PhoneInput.vue")
            break;
          case 'client_location':
          case 'default_business_location':
          case 'business_location':
            res = () => import("@/modules/common/components/GoogleAddressInput/GoogleAddressInput.vue")
        }
        return res
      }
    }

  };
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

</style>
